export default "__VITE_ASSET__CIgsKVPO__"